import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { useComparisonMode } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { KeyMeasuresOverTime } from '../../filters/key-measures-over-time/key-measures-over-time';
import { MeasureComparison } from '../../filters/measure-comparison/measure-comparison';
import { MonthlyAverages } from '../../filters/monthly-averages/monthly-averages';
import { ComparisonMode, MultipleViewMode } from '../../process-analysis.type';

export const FiltersContent = () => {
  const comparisonMode = useComparisonMode();
  const multipleViewMode = useProcessAnalysisStore((state) => state.multipleViewMode);

  if (comparisonMode === ComparisonMode.Multiple) {
    switch (multipleViewMode) {
      case MultipleViewMode.KeyMeasuresOverTime:
        return <KeyMeasuresOverTime />;
      case MultipleViewMode.MonthlyAverages:
        return <MonthlyAverages />;
      default:
        return null;
    }
  }

  if (comparisonMode === ComparisonMode.Single) {
    return <MeasureComparison />;
  }

  return null;
};
